<nav class="ct-tabs">
  <a routerLink="/cities" routerLinkActive="active" [routerLinkActiveOptions]="citiesLink">{{ 'cities.tabs.cities' | transloco }}</a>
  <a routerLink="/cities/countries" routerLinkActive="active">{{ 'cities.tabs.countries' | transloco }}</a>
</nav>
